import { render, staticRenderFns } from "./ContentBlockTrainingItemURL.vue?vue&type=template&id=a2173e66&"
import script from "./ContentBlockTrainingItemURL.vue?vue&type=script&lang=js&"
export * from "./ContentBlockTrainingItemURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports